const statusMessages = {
  400: "Error de validación.",
  404: "No encontrado.",
  409: "Este dato ya existe. Introduce uno diferente.",
  500: "Error inesperado en el servidor.",
};

const formatValidationMessage = (data) => {
  const messages = data?.message;
  if (Array.isArray(messages)) {
    return messages.join(" \n");
  }
  if (typeof messages === "string") {
    return messages;
  }
  return statusMessages[400];
};

export const handleApiError = (error) => {
  const statusCode =
    error?.status || error?.statusCode || error?.response?.status || 500;
  const payload = error?.response?.data ?? error?.data;

  let message = statusMessages[statusCode] || statusMessages[500];

  switch (statusCode) {
    case 400:
      message = formatValidationMessage(payload);
      break;
    case 404:
    case 409:
      message = statusMessages[statusCode];
      break;
    case 500:
      message = statusMessages[500];
      break;
    default:
      message = payload?.message || error?.message || statusMessages[500];
      break;
  }

  return { success: false, message, statusCode };
};

export default handleApiError;
